import React, { Component } from "react";
import { Modal, Form, Input } from "antd";
import http from "../../../axios/http";

const FormItem = Form.Item;

class BarrierMemberEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onDateChange = (item, val) => {
    this.props.editData.expireDate = val;
  };

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      http.post({
        url: "/barrier/plateNoCard/savemember",
        data: values,
        success: (res) => {
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Modal
        visible={visible}
        title="道闸商户编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="编号：">
            {getFieldDecorator("code", {
              rules: [
                { required: true, message: "请输入编号!" },
                { max: 10, message: "最多只能输入10个字符！" },
              ],
              initialValue: editData.code,
            })(<Input />)}
          </FormItem>
          <FormItem label="名称：">
            {getFieldDecorator("name", {
              rules: [{ max: 30, message: "最多只能输入30个字符！" }],
              initialValue: editData.name,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const BarrierMemberEdit = Form.create()(BarrierMemberEditForm);

export default BarrierMemberEdit;
